import {
  useFetchSupportArticles,
  useArticleNavigation as useArticleNavigationCore,
} from "@core/features/support";

export type Args = {
  articleId: string | null;
  programId?: string;
};

/**
 * Platform-specific wrapper for useArticleNavigation.
 * Automatically fetches categories from useFetchSupportArticles.
 */
export function useArticleNavigation({ articleId, programId }: Args) {
  const { data } = useFetchSupportArticles(programId);
  const categories = data?.categories ?? [];

  return useArticleNavigationCore({ articleId, categories });
}

export default useArticleNavigation;

